import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PermissionEnum } from '@ui/src';

import {
  notificationCenterDictionariesApi,
  PermissionResponse,
} from './services';

export interface NotificationCenterDitionariesState {
  activePermissions?: PermissionEnum[];
  whitelabel?: {
    data: {
      value: Record<string, string>;
    };
  };
}

const initialState: NotificationCenterDitionariesState = {};

export const notificationCenterDictionariesSlice = createSlice({
  name: 'notificationCenterDictionaries',
  initialState,
  reducers: {
    setActivePermissions: (state, action: PayloadAction<PermissionEnum[]>) => {
      state.activePermissions = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        notificationCenterDictionariesApi.endpoints
          .getNotificationCenterPermissions.matchFulfilled,
        (state, action: PayloadAction<{ data: PermissionResponse }>) => {
          state.activePermissions = action.payload.data.permissions;

          localStorage.setItem(
            'activePermissions',
            JSON.stringify(action.payload.data.permissions),
          );
        },
      )
      .addMatcher(
        notificationCenterDictionariesApi.endpoints
          .getNotificationCenterWhitelabel.matchFulfilled,
        (
          state,
          action: PayloadAction<{
            data: {
              data: {
                value: Record<string, string>;
              };
            };
          }>,
        ) => {
          state.whitelabel = action.payload.data;
        },
      );
  },
});

export const { setActivePermissions } =
  notificationCenterDictionariesSlice.actions;

export default notificationCenterDictionariesSlice.reducer;
